/**
 * Filter functionality for theme overview.
 */

( function( $ ) {
    $( document ).on( 'click', 'a[data-filter-bar-option]', function ( event ) {
        event.preventDefault();

        if ( !$( '[data-filter-bar-target]' ).length ) {
            console.warn( 'Filter target not found' );
            return false;
        }

        var template = 'theme';

        if ($(this).parents('[data-filter-bar-template]').length) {
            template = $(this).parents('[data-filter-bar-template]').data('filter-bar-template');
        }

        $( '.filter-bar-option' ).removeClass( 'active' );
        $( this ).parent().addClass( 'active' );

        var portnumber = title_search = '';

        if (window.location.port.length) {
            portnumber = ":" + window.location.port;
        }

        if( $('.page-header-search-input').length ) {
            title_search = $('.page-header-search-input').val();
        }

        var term_id = $( this ).data( 'filter-bar-option' ),
            url     = window.location.protocol + "//" + window.location.hostname + portnumber + window.location.pathname;

        if( url.length ) {
            url = url + ( url.indexOf( "?" ) > 0 ? "&" : "?" ) + "filter-option=" + term_id;
            if (title_search.length) {
                url = url + "&title_search=" + title_search
            }
            history.replaceState( { 'filter-option' : term_id, 'title_search' : title_search }, null, url );
        }

        if ($('#page-header-search-filter-option').length) {
            $('#page-header-search-filter-option').val(term_id);
        }

        $.ajax( {
            url      : themevars.ajaxurl,
            data     : {
                action   : 'filter_bar',
                term_id  : term_id,
                title_search : title_search,
                template : template,
                afp_nonce: themevars.afp_nonce
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( result ) {

            var $target = $('[data-filter-bar-target]');
            $target.empty();

            // update load more button
            if( undefined !== result.data.load_more_button ) {
                if( $( 'a[data-load-more]' ).length ) {
                    $( '[data-load-more-container]' ).html( result.data.load_more_button );
                } else {
                    $( '[data-load-more-container]' ).append( result.data.load_more_button );
                }
            } else {
                $( '[data-load-more-container]' ).html( "" );
            }

            $spotlight_element = false;

            // hide spotlight items if filtering on theme on advice overview
            if ($('.advice-spotlight').length) {
                $spotlight_element = $('.advice-spotlight');
            }

            // hide spotlight items if filtering on test type on test overview
            if ($('.stick-tests-container').length) {
                $spotlight_element = $('.stick-tests-container');
            }

            if ($spotlight_element && $spotlight_element.length) {
                if(term_id) {
                    if(!$spotlight_element.hasClass('d-none')) {
                        $spotlight_element.addClass('d-none');
                    }
                } else {
                    $spotlight_element.removeClass('d-none');
                }
            }

            if( true !== result.success || undefined === result.data.posts ) {
                $target.append( '<div class="col-12 text-center no-results-message">Geen resultaten</div>' );
                return;
            }
            
            $target.append( result.data.posts );
        });
    });
} )( jQuery );

